var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lock",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 16,
    height: 21,
    fill: "#F7F5F5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#F7F5F5",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1766",
    "data-name": "Groupe 1766",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1765",
    "data-name": "Groupe 1765",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_410",
    "data-name": "Trac\\xE9 410",
    d: "M14,7H13V5A5,5,0,0,0,3,5V7H2A2.006,2.006,0,0,0,0,9V19a2.006,2.006,0,0,0,2,2H14a2.006,2.006,0,0,0,2-2V9a2.006,2.006,0,0,0-2-2M5,5a3,3,0,0,1,6,0V7H5Zm9,14H2V9H14ZM8,16a2,2,0,1,0-2-2,2.006,2.006,0,0,0,2,2",
    fill: "#F7F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOutlined);
export default __webpack_public_path__ + "static/media/LockOutlined.5b27ee0957c29a51178bb35792ab6485.svg";
export { ForwardRef as ReactComponent };